import React, { useEffect, useRef, useState } from 'react';
import { formatDistanceToNow } from "date-fns";
import { cloneDeep } from 'lodash';

import { default as Toast } from './Toast'


export const ADD_TOAST = "ADD_TOAST";
export const DEL_TOAST = "DEL_TOAST";
export const DEL_MULTIPLE_TOAST = "DEL_MULTIPLE_TOAST";



export interface ToastState {
  list: ToastTypeWithId[]
}

const initial_state = {
  list: [] as ToastTypeWithId[],
}


export function toastReducer(state: ToastState = initial_state, action: ToastAction) {
  if (action.type == ADD_TOAST) {
    const new_toast = action.toast as ToastTypeWithId;
    const last_id = (state.list.length > 0) ?
      Math.max(...state.list.map(item => item.id)) :
      -1;
    new_toast.id = last_id + 1;
    const nuova_lista = Object.assign(
      [],
      [action.toast, ...state.list]
    )
    const copia = cloneDeep(state);
    copia.list = nuova_lista;
    return copia;
  } else if (action.type == DEL_TOAST) {
    const copia = cloneDeep(state);
    copia.list = copia.list.filter(item => item.id != action.index)
    return copia;
  } else if (action.type == DEL_MULTIPLE_TOAST) {
    const copia = cloneDeep(state);
    copia.list = copia.list.filter(item => (item.title != action.title
      || item.generating_object != action.generating_object))
    return copia;
  } else {
    return state;
  }
}



export interface ToastType {
  title: string,
  message: string | React.ReactComponentElement<any>,
  time?: Date,
  generating_object?: string,
  store: any
}

export interface ToastTypeWithId extends ToastType {
  id: number
}


export interface ToastAction {
  type: typeof ADD_TOAST | typeof DEL_TOAST,
  toast?: ToastType,
  index?: number,
  title?: string,
  generating_object?: string,
}


export function add_toast_action(toast: ToastType) {
  return {
    type: ADD_TOAST,
    toast: toast,
  }
}

export function del_toast_action(toast: number) {
  return {
    type: DEL_TOAST,
    index: toast,
  }
}


export function delete_old_toasts(toast: ToastType) {
  return {
    type: DEL_MULTIPLE_TOAST,
    title: toast.title,
    generating_object: toast.generating_object,
  }
}




const ToastFeed = ({ useToast }: { useToast: () => ToastState }) => {
  const toasts = useToast();

  return (
    <div
      aria-live="polite" aria-atomic="true"
      style={{ position: 'fixed', top: 55, right: 0, zIndex: 100000, }}
      className="mt-2 mr-2 ml-2"
    >
      <div style={{ position: 'relative', top: 0, right: 0 }} >
        {
          toasts.list.map(item => {
            return <ToastWithTime
              key={item.id}
              {...item}
            />;
          })
        }
      </div>
    </div>
  );
}


const ToastWithTime = (props: ToastTypeWithId) => {

  const [forceRefresh, setForceRefresh] = useState(1);
  const [start, setStart] = useState<Date | null>(null);
  const timer = useRef<number | null>(null);

  useEffect(() => {
    timer.current = window.setInterval(() => setForceRefresh(val => val + 1), 1000);
    setStart(props.time || new Date());

    return () => {
      if (!!timer.current) {
        window.clearInterval(timer.current)
      }
    }
  }, [props.time])


  return (
    <Toast
      onClose={() => props.store.dispatch(del_toast_action(props.id))}
    >
      <Toast.Header>
        <strong className="mr-3">{props.title}</strong>
        <small>{!!start && formatDistanceToNow(start, { includeSeconds: true })}</small>
      </Toast.Header>
      <Toast.Body>{props.message}</Toast.Body>
    </Toast>
  );
}


export default ToastFeed;
